import { render, staticRenderFns } from "./AssignBannerModal.vue?vue&type=template&id=e80cd7bc&scoped=true&"
import script from "./AssignBannerModal.vue?vue&type=script&lang=js&"
export * from "./AssignBannerModal.vue?vue&type=script&lang=js&"
import style1 from "./AssignBannerModal.vue?vue&type=style&index=1&id=e80cd7bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80cd7bc",
  null
  
)

export default component.exports